import { Grow, Stack, Typography } from '@mui/material';
import ProductPreviewV3 from './ProductPreviewV3';
import { FontAwesomeIcon } from '@appcharge/shared-ui';

const CheckoutThemePreviewV3 = ({
  logo,
  primaryColor,
  textColor,
  bgImage,
  bgMobileImage,
  fontFamily,
  onClose
}: {
  logo: string;
  primaryColor: string;
  textColor: string;
  bgImage: string;
  bgMobileImage: string;
  onClose: () => void;
  fontFamily: string;
}) => {
  return (
    <Stack
      width="100%"
      height="100vh"
      position="absolute"
      top={0}
      left={0}
      zIndex={9999}
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.75)'
      }}
      onClick={() => onClose()}
    >
      <Grow in>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          gap={8}
        >
          <Stack direction="column" gap={2} alignItems="center">
            <Typography variant="h6" color={'white'} fontWeight={400}>
              Desktop
            </Typography>
            <Stack
              width="740px"
              height="800px"
              sx={{ backgroundColor: 'white' }}
              borderRadius="15px"
              direction="row"
            >
              <Stack
                width="390px"
                sx={{
                  background: primaryColor,
                  backgroundImage: `url(${bgImage})`,
                  borderTopLeftRadius: '15px',
                  borderBottomLeftRadius: '15px',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center top'
                }}
                direction="column"
                gap={2}
                px={'32px'}
                py={'16px'}
              >
                <Stack
                  mt={2}
                  alignItems="center"
                  display="flex"
                  flexDirection={'row'}
                  gap={1}
                >
                  <img
                    src={logo}
                    alt="logo"
                    style={{ height: '42px', objectFit: 'contain' }}
                  />
                  <Typography
                    className="text-md"
                    color={textColor}
                    fontFamily={fontFamily}
                  >
                    Special Offer
                  </Typography>
                </Stack>
                <Stack direction="column">
                  <Stack
                    direction="column"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
                    borderRadius={'7px'}
                  >
                    <ProductPreviewV3
                      textColor={textColor}
                      name="Coins"
                      quantity="100,000"
                      imageUrl="./assets/images/checkout_item_1_v3.png"
                    />
                    <ProductPreviewV3
                      textColor={textColor}
                      name="Booster"
                      quantity="10,000"
                      imageUrl="./assets/images/checkout_item_2_v3.png"
                    />
                    <ProductPreviewV3
                      textColor={textColor}
                      name="XP"
                      quantity="1,000"
                      imageUrl="./assets/images/checkout_item_3_v3.png"
                    />
                  </Stack>
                  <div className="flex flex-col gap-1">
                    <div className="relative flex items-center border-1 rounded-md transition-all duration-200 focus-within:border-muted-foreground order-base-border">
                      <input
                        type="text"
                        placeholder="Promo Code"
                        value={''}
                        onChange={() => {}}
                        className="flex-1 p-2 h-10 pl-3 rounded-md outline-0 text-base md:text-sm font-family-sans appearance-none text-card-foreground bg-white cursor-default"
                      />
                      <div className="absolute right-4 flex items-center gap-2">
                        <FontAwesomeIcon
                          icon="fa-regular fa-tag"
                          className="text-card-foreground"
                        />
                      </div>
                    </div>
                  </div>
                  <Stack direction="column" gap={1.25} mt={2}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        Subtotal
                      </Typography>
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        $ 19.90
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        Tax (0%)
                      </Typography>
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        $ 0
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography
                        color={textColor}
                        fontSize={'16px'}
                        fontWeight={500}
                        fontFamily={fontFamily}
                      >
                        Total
                      </Typography>
                      <Typography
                        color={textColor}
                        fontSize={'16px'}
                        fontWeight={500}
                        fontFamily={fontFamily}
                      >
                        $ 19.90
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
              <Stack
                width="100%"
                sx={{
                  background: 'white',
                  borderTopRightRadius: '15px',
                  borderBottomRightRadius: '15px'
                }}
                pt={2}
                alignItems="center"
                position={'relative'}
              >
                <FontAwesomeIcon
                  icon="fa-regular fa-xmark"
                  className="absolute right-4 w-9 h-9"
                />
                <img
                  src={'./assets/images/checkout_theme_payments_v3.png'}
                  alt="checkout-theme-preview"
                />
              </Stack>
            </Stack>
          </Stack>
          <Stack direction="column" gap={2} alignItems="center">
            <Typography variant="h6" color={'white'} fontWeight={400}>
              Mobile
            </Typography>
            <Stack
              width="340px"
              height="800px"
              sx={{ backgroundColor: 'white' }}
              borderRadius="15px"
              direction="column"
              overflow="hidden"
            >
              <Stack
                width="100%"
                sx={{
                  background: primaryColor,
                  backgroundImage: `url(${
                    bgMobileImage !== ''
                      ? bgMobileImage
                      : bgImage !== ''
                        ? bgImage
                        : 'none'
                  })`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center top'
                }}
                direction="column"
                gap={2}
                px={'16px'}
                py={'16px'}
                position="relative"
              >
                <div
                  onClick={() => onClose()}
                  className="close-button"
                  style={{
                    cursor: 'pointer',
                    width: '25px',
                    height: '25px',
                    position: 'absolute',
                    right: '7px'
                  }}
                >
                  <FontAwesomeIcon
                    icon="fa-regular fa-xmark"
                    style={{ color: textColor }}
                  />
                </div>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  height="48px"
                  mt={2}
                >
                  <Stack
                    alignItems="center"
                    display="flex"
                    flexDirection={'row'}
                    gap={1}
                  >
                    <img
                      src={logo}
                      alt="logo"
                      style={{ height: '48px', objectFit: 'contain' }}
                    />
                    <Typography
                      fontSize={'14px'}
                      fontWeight={600}
                      textAlign="center"
                      style={{ color: textColor }}
                      fontFamily={fontFamily}
                    >
                      Special Offer
                    </Typography>
                  </Stack>
                  <Stack direction="row" gap={0.5} alignItems="center">
                    <FontAwesomeIcon
                      icon="fa-regular fa-tag"
                      style={{ color: textColor }}
                    />
                    <Typography
                      className="font-medium text-center"
                      fontSize={'12px'}
                      color={textColor}
                      fontFamily={fontFamily}
                    >
                      Details
                    </Typography>
                    <FontAwesomeIcon
                      icon="fa-regular fa-chevron-down"
                      style={{ color: textColor }}
                    />
                  </Stack>
                </Stack>
                <Stack direction="row" gap={2} justifyContent="space-between">
                  <Typography
                    variant="h6"
                    color={textColor}
                    fontFamily={fontFamily}
                    fontSize={'1em'}
                    fontWeight={500}
                    boxSizing={'border-box'}
                  >
                    Total
                  </Typography>
                  <Typography
                    variant="h6"
                    color={textColor}
                    fontFamily={fontFamily}
                    fontSize={'1em'}
                    fontWeight={500}
                    boxSizing={'border-box'}
                  >
                    $ 19.90
                  </Typography>
                </Stack>
              </Stack>
              <img
                src={'./assets/images/checkout_theme_payments_v3_mobile.png'}
                alt="checkout-theme-preview"
              />
            </Stack>
          </Stack>
        </Stack>
      </Grow>
    </Stack>
  );
};

export default CheckoutThemePreviewV3;
